import React, { cloneElement, isValidElement, ReactNode } from 'react';
import styles from '../styles.module.css';
import LogoSection from '@/components/structure/Toolbar/LogoSection';
import MainIcons from '@/icons/main';

export default function Template({
  children,
  side,
  className = '',
}: {
  children?: ReactNode;
  side?: ReactNode;
  className?: string;
}) {
  const badges = [
    {
      icon: <MainIcons.shieldIcon />,
      text: 'مرجع رسمی راهور',
    },
    {
      icon: <MainIcons.LockIcon />,
      text: 'پرداخت امن',
    },
    {
      icon: <MainIcons.clockIcon />,
      text: 'نتیجه در ۱ ثانیه',
    },
  ];
  return (
    <div className={`${styles.page} ${className}`}>
      <aside className={styles.sidebar}>
        <div className={styles.orangeGlow} />
        <div className={styles.blueGlow} />
        <div className={styles.gridOverlay} />

        <LogoSection />

        <div className={styles.body}>
          {side}

          <div className={styles.badges}>
            {badges?.map((badge) => (
              <div key={badge.text} className={styles.badge}>
                {isValidElement(badge.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
                  ? cloneElement(badge?.icon, {
                      fill: 'var(--green-bright)',
                      width: `${'16px'}`,
                      height: `${'16px'}`,
                    })
                  : badge?.icon}

                <span>{badge?.text}</span>
              </div>
            ))}
          </div>
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.content}>
          <LogoSection className={`${styles.mobileLogo}`} />
          {children}
        </div>
      </main>
    </div>
  );
}
